var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { media } from "../../index";

var Responsive = function Responsive(_ref) {
  var children = _ref.children,
      _ref$as = _ref.as,
      as = _ref$as === undefined ? "div" : _ref$as,
      hide = _ref.hide,
      show = _ref.show,
      restProps = _objectWithoutProperties(_ref, ["children", "as", "hide", "show"]);

  return React.createElement(
    Wrapper,
    _extends({ as: as, hide: hide, show: show }, restProps),
    children
  );
};

export { Responsive };
Responsive.propTypes = process.env.NODE_ENV !== "production" ? {
  as: PropTypes.string,
  show: PropTypes.string,
  hide: PropTypes.string
} : {};

var Wrapper = styled.div.withConfig({
  displayName: "Responsive__Wrapper",
  componentId: "sc-2448d7-0"
})(["", ";", ";"], function (props) {
  return props.show && css(["display:none;", ";"], media.up[props.show](css(["display:initial;"])));
}, function (props) {
  return props.hide && media.up[props.hide](css(["display:none;"]));
});